module.exports = __webpack_public_path__ + "static/media/biteship-dhl.3abd138f.png";